import { Module } from "vuex";

import { IRootState } from "@/store";
import { getters } from "@/store/modules/documentConstructor/getters";
import { actions } from "@/store/modules/documentConstructor/actions";
import { mutations } from "@/store/modules/documentConstructor/mutations";
import {
  IDocumentConstructorState,
  state,
} from "@/store/modules/documentConstructor/state";

export const documentConstructor: Module<
  IDocumentConstructorState,
  IRootState
> = {
  actions,
  mutations,
  state,
  getters,
};
